import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="multi-input"
export default class extends Controller {
  static targets = ["inputs", "inputContainer"]
  static values = {
    fieldName: String,
  }

  addField(e){
    e.preventDefault()

    const inputsTarget = this.inputsTarget

    const inputContainer = this.inputContainerTargets[this.inputContainerTargets.length - 1]
    const clonedInputContainer = inputContainer.cloneNode(true) // clone deep

    inputsTarget.appendChild(clonedInputContainer)
  }

  removeField(e){
    e.preventDefault()

    if (this.inputContainerTargets.length === 1){
      return alert('Need at least 1 input')
    }

    const inputContainer = e.target.closest('[data-multi-input-target="inputContainer"]')
    if (inputContainer){
      inputContainer.remove()
    }
  }
}
